import AnimatedBurger from 'components/AnimatedBurger'
import Link from 'components/Link'
import * as CompaniesLogos from 'components/Logo'
import { useSearch } from 'components/Search/SearchContext'
import { motion } from 'framer-motion'
import { Search } from 'components/Icons/Icons'
import { graphql, useStaticQuery } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react'
import MenuItem from './MenuItem'
export { keyboardShortcut, InternalMenu, ActiveBackground, Tooltip, Mobile, Main } from './utils'
import { prepareData } from 'utils/googleData'

export function MainNav({ logo }) {
    const { i18n } = useTranslation()
    const { homeMenu } = useStaticQuery(query)
    // const { navsJson } = useStaticQuery(query2)
    const result = prepareData({
        props: homeMenu?.nodes?.[0]?.parent,
    })
    let menu = []
    if (Array.isArray(result)) {
        menu = result
    } else {
        for (const key of Object.keys(result)) {
            if (!isNaN(key)) {
                menu.push(result[key])
            }
        }
    }
    const Logo = logo && CompaniesLogos[logo]
    // const { enable, socialList, direction, linkList, name, Icon }  = result
    // console.log(`extractpropvalue ${JSON.stringify(menu)} length is ${menu?.length} `)
    if (
        (menu?.enable === false || menu?.enable?.toLowerCase?.() === 'false') &&
        !process.env.RENDER_DISABLED_COMPONENTS
    ) {
        return <></>
    }
    const [expanded, expandMenu] = useState(false)
    const [referenceElement, setReferenceElement] = useState(null)
    // const menu = linkList //|| navsJson?.main
    const breakpoints = useBreakpoint()
    const variants = {
        hidden: { height: 0 },
        shown: { height: 'auto' },
    }
    const menuLength = menu?.length
    const halfMenu = Math.floor(menuLength / 2)

    const { open } = useSearch()
    return (
        <div className="max-w-screen-3xl mx-auto flex items-center justify-between lg:relative">
            <button
                className="flex h-[36px] w-[36px] items-center justify-center rounded-full bg-gray-accent-light active:top-[0.5px] active:scale-[.98] dark:bg-gray-accent-dark lg:hidden"
                onClick={() => open('mobile-header')}
            >
                <Search className="h-[16px] w-[16px]" />
            </button>
            <Link
                className="block text-primary hover:text-primary dark:text-primary-dark dark:hover:text-primary-dark lg:hidden"
                to="/"
            >
                {Logo && <Logo />}
            </Link>
            <AnimatedBurger
                className="flex h-[36px] w-[36px] items-center justify-center rounded-full bg-gray-accent-light active:top-[0.5px] active:scale-[.98] dark:bg-gray-accent-dark lg:hidden"
                onClick={() => expandMenu(!expanded)}
                active={expanded}
            />
            {(expanded || !breakpoints.md) && (
                <motion.nav
                    className="absolute left-0 top-full hidden w-full overflow-hidden lg:static lg:block lg:overflow-visible"
                    variants={breakpoints.md && variants}
                    initial="hidden"
                    animate="shown"
                >
                    <div
                        ref={setReferenceElement}
                        className="max-w-screen-3xl z-50 mx-auto flex flex-col items-start justify-between bg-white py-5 font-nav text-white dark:bg-gray-accent-dark lg:-mx-3 lg:flex-row lg:items-center lg:bg-transparent lg:py-0 lg:text-almost-black lg:dark:bg-transparent lg:dark:text-white"
                    >
                        <ul className="m-0 flex w-full flex-1 list-none flex-col space-x-[1px] p-0 lg:w-auto lg:flex-row">
                            {menu.slice(0, halfMenu).map((menuItem, index) => {
                                if (
                                    (menuItem.enable === false || menuItem.enable?.toLowerCase?.() === 'false') &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return null
                                }
                                if (
                                    i18n.language == 'ar' &&
                                    (menuItem.enable_ar === false || menuItem.enable_ar?.toLowerCase?.() === 'false') &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return null
                                }
                                return (
                                    <MenuItem
                                        referenceElement={referenceElement}
                                        key={`first-${index}`}
                                        menuItem={menuItem}
                                    />
                                )
                            })}
                        </ul>
                        {!breakpoints.md && (
                            <Link
                                className="relative hidden text-primary hover:scale-[1.01] hover:text-primary active:top-[0.5px]
                                active:scale-[.99]
                                dark:text-primary-dark
                                dark:hover:text-primary-dark
                                lg:block"
                                to="/"
                            >
                                <Logo />
                            </Link>
                        )}
                        <ul className="m-0 flex w-full flex-1 list-none flex-col justify-end p-0 lg:w-auto lg:flex-row">
                            {menu.slice(halfMenu, menu.length).map((menuItem, index) => {
                                if (
                                    (menuItem.enable === false || menuItem.enable?.toLowerCase?.() === 'false') &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return null
                                }
                                if (
                                    i18n.language == 'ar' &&
                                    (menuItem.enable_ar === false || menuItem.enable_ar?.toLowerCase?.() === 'false') &&
                                    !process.env.RENDER_DISABLED_COMPONENTS
                                ) {
                                    return null
                                }
                                return (
                                    <MenuItem
                                        referenceElement={referenceElement}
                                        key={`second-${index}`}
                                        menuItem={menuItem}
                                    />
                                )
                            })}
                        </ul>
                    </div>
                </motion.nav>
            )}
        </div>
    )
}
export default MainNav

const query = graphql`
    query MainMenu {
        homeMenu: allMdx(filter: { fields: { slug: { eq: "/" } }, frontmatter: { title: { ne: "" } } }) {
            nodes {
                id
                parent {
                    ... on GoogleDocs {
                        id
                        allMenu: homeMenu {
                            component
                            i18
                            title
                            title_ar
                            icon
                            section
                            classes
                            toggle
                            url
                            enable
                            name
                            name_ar
                            hideBorder
                            socialList {
                                url
                                icon
                                style
                                color
                                enable
                            }
                            linkList {
                                type
                                url
                                enable
                                title
                                title_ar
                                subtitle
                                subtitle_ar
                                icon
                                component
                                cta {
                                    url
                                    title
                                    title_ar
                                    enable
                                }
                                items {
                                    section
                                    title
                                    title_ar
                                    subtitle
                                    subtitle_ar
                                    style
                                    enable
                                    type
                                    urlTemplate
                                    subitems {
                                        enable
                                        text
                                        icon
                                        title
                                        title_ar
                                        url
                                        description
                                        description_ar
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

const query2 = graphql`
    query MainNavQuery {
        navsJson {
            main {
                title
                url
                toggle
                classes
                hideBorder
                items: sub {
                    component
                }
            }
        }
    }
`
